module.exports = __webpack_public_path__ + "img/bus3.5725e7b4.png";